(function(){
  'use strict';  

  theme.announcementBar = (function() {
    var args = {
      autoPlay: 5000,
      avoidReflow: false,
      cellAlign: theme.config.rtl ? 'right' : 'left'
    };

    var selectors = {
      bar: '.announcement-bar',
      text: '.announcement__text',
      closeBtn: '.announcement__close',
      
      wrapper: '#HeaderWrapper',
      siteHeader: '#AnnouncementWrapper',
      
      dynamicHeader: '#DynamicAnnouncement'
    };
  
    var classes = {
      opening: 'announcement--opening',
      closed: 'announcement--closed',
    };
  
    var config = {
      namespace: '.announcementBar',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      overlayEnabledClass: 'header-wrapper--overlay',
      stickyEnabled: false,
      stickyActive: false,
      stickyHeaderWrapper: 'StickyHeaderWrap',
      openTransitionClass: 'announcement-bar--opening',
      lastScroll: 0
    };
    var bar;
    var flickity;
    
    var wrapper;
    var siteHeader;
    
    var dynamic_link;
  
    function init() {
      siteHeader = document.querySelector(selectors.siteHeader);
      if (!siteHeader) {
        return
      }
      
      var isBarClosed = Cookies.get('isBarClosed');
      if (isBarClosed == 'true') {
        announcementBarClose()
        return
      }

      wrapper = document.querySelector(selectors.wrapper);
      

      config.stickyEnabled = (siteHeader.dataset.sticky === 'true');
      config.wrapperOverlayed = wrapper.classList.contains(config.overlayedClass);
      stickyHeader();


      bar = document.getElementById('AnnouncementSlider');
      if (!bar) {
        return;
      }
  
      unload();
      
      if (bar.dataset.blockcount && parseInt(bar.dataset.blockcount) < 2) {
        return;
      }
  
      if (theme.config.bpSmall || bar.dataset.compact === 'true') {
        initSlider();
      }
  
      document.addEventListener('matchSmall', function() {
        unload();
        if (bar.dataset.compact === 'true') {
         initSlider();
        }
      });
  
      document.addEventListener('unmatchSmall', function() {
        unload();
        if (bar.dataset.compact === 'true') {
          initSlider();
        }
      });
      
      if (!document.querySelector(selectors.closeBtn)) {
        return;
      }

      document.querySelector(selectors.closeBtn).addEventListener('click', announcementBarClose);
    }
  
    function initSlider() {
      flickity = new theme.Slideshow(bar, args);

      resizeSilder()
    }

    function resizeSilder() {
      var announcementSlider = siteHeader.querySelectorAll('.announcement-slider__wrapper')
      var flickityContainer = siteHeader.querySelector(".flickity-viewport")
      var biggestHeight = 0;

      announcementSlider.forEach(
        function(element) {
          biggestHeight = element.offsetHeight > biggestHeight ? element.offsetHeight : biggestHeight;
        }
      );

      if (flickityContainer) {
        flickityContainer.style.height = biggestHeight + 'px'
      }      
    }
  
    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector('#AnnouncementSlide-' + id);
      var index = parseInt(slide.dataset.index);
  
      if (flickity && typeof flickity.pause === 'function') {
        flickity.goToSlide(index);
        flickity.pause();
      }
    }
  
    function onBlockDeselect() {
      if (flickity && typeof flickity.play === 'function') {
        flickity.play();
      }
    }
  
    function unload() {
      if (flickity && typeof flickity.destroy === 'function') {
        flickity.destroy();
      }
    }

    function announcementBarClose() {
      if (theme.config.hasSessionStorage) {
        Cookies.set(announcementBarText(), 'hidden');
      }
      
      Cookies.set('isBarClosed', 'true');
      
      document.querySelector(selectors.bar).classList.add(classes.closed);

      var siteHeader = document.querySelector('#SiteHeader');
      siteHeader.style.top = 0+'px'
    }
  
    function announcementBarText() {
      var elem = document.querySelector(selectors.text)
      if (elem) {
        return document.querySelector(selectors.text).dataset.text;
      }
    }
    
    function stickyHeader() {
      var wrapperDiv = document.createElement('div');
      wrapperDiv.id = config.stickyHeaderWrapper;
      theme.Helpers.wrap(siteHeader, wrapperDiv);
    }
  
    var shippingBar = document.querySelector('.free-shipping-bar');
    
    
    function update(){
      var isBarClosed = Cookies.get('isBarClosed');

      if (shippingBar == null || isBarClosed == 'true') {
        return
      }
      var promote_txt = shippingBar.dataset.promote;
      var empty = shippingBar.dataset.empty;
      var unlocked_txt = shippingBar.dataset.unlocked;
      var threshold = shippingBar.dataset.threshold;
      var items = shippingBar.dataset.items;
      var array_has_item = false;
      var isItemEnabled = false;
      var link_txt = shippingBar.dataset.link;
      var announcementBar = document.querySelector('.announcement-bar');
      var dynamicAnnouncement = document.querySelector(selectors.dynamicHeader);

      fetch('/cart.js')
      .then(function(response){
        return response.json();
      })
      .then(function(cart){
        var value_left = threshold - cart.total_price;
        var value_left_money = theme.Currency.formatMoney(value_left,theme.moneyFormat);

        if (items != "") {
          isItemEnabled = true;
          for (var i = 0; i < cart.items.length; i++) {
            array_has_item = items.includes(cart.items[0].product_id)
            if (array_has_item == true ) {
              break;
            }
          }
        }

        var link_html = "";
        if (link_txt != "") {
          link_html = '<span class="announcement-link-text">'+link_txt+'</span>'
        }

        if(cart.total_price == 0 || promote_txt == "" && unlocked_txt == "") {
          if (cart.total_price != 0) {
            shippingBar.innerHTML = '<span class="announcement-text">'+empty.replace('[value]',value_left_money)+'</span>' + link_html;
          } else {
            shippingBar.innerHTML = '<span class="announcement-text">'+empty.replace('[value]',value_left_money)+'</span>';
          }
          announcementBar.classList.remove('promote_txt');
          announcementBar.classList.remove('unlocked_txt');
        } else {
          if(isItemEnabled == false && value_left<=0 || isItemEnabled == true && array_has_item == true || isItemEnabled == true && array_has_item == false && value_left<=0) {
            shippingBar.innerHTML = '<span class="announcement-text">'+unlocked_txt+'</span>';
            announcementBar.classList.add('unlocked_txt');
            announcementBar.classList.remove('promote_txt'); 
            if (dynamicAnnouncement != null) {
              dynamicAnnouncement.setAttribute('href', window.location.origin + '/cart');
            }
          } else {
            shippingBar.innerHTML = '<span class="announcement-text">'+promote_txt.replace('[value]',value_left_money)+'</span>' + link_html;
            announcementBar.classList.remove('unlocked_txt');
            announcementBar.classList.add('promote_txt');
            if (dynamicAnnouncement != null) {
			  dynamicAnnouncement.setAttribute('href', window.location.origin + dynamicAnnouncement.dataset.href);
            }
          }
        }

        resizeSilder()
        //theme.headerNav.resizeHeader()
      })
    }

    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload,
      update:update
    };
  })();
  
  theme.HeaderSection = (function() {
    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.init();
    }
  
    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function() {
        this.container.querySelectorAll(".image-grid-item--loader").forEach((el) => {
          el.classList.remove('loading', 'loading--delayed');
          el.classList.add('loaded');
        });

        if (Shopify && Shopify.designMode) {
          
          for (var i = 0; i < theme.sections.instances.length; i++) {
            var instance = theme.sections.instances[i];
            if (instance['type'] === 'slideshow-section') {
              instance.forceReload();
            }
          }
        }
  
        if (this.container.querySelector("#HeaderWrapper")) {
          this.initDrawers();
          theme.headerNav.init();
        }

        if (this.container.querySelector("#SiteAnnouncement")) {
          theme.announcementBar.init();      
          theme.announcementBar.update();
        }
      },
  
      initDisclosures: function() {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);
  
        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }
  
        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
      },
  
      initDrawers: function() {
        theme.MenuDrawer = new theme.Drawers('MenuDrawer', 'nav');
        if (this.container.parentElement.querySelector("#CartDrawer")) {
          if (!document.body.classList.contains('template-cart')) {
            new theme.CartDrawer();
          }
        } 
  
        theme.collapsibles.init(document.getElementById('MenuDrawer'));
      },
  
      onUnload: function() {
        theme.MenuDrawer.close();
       theme.announcementBar.unload();
        theme.announcementBar.update();
      }
    });
  
    return HeaderSection;
  })();
  
  theme.headerNav = (function() {
    var selectors = {
      wrapper: '#HeaderWrapper',
      siteHeader: '#SiteHeader',
      searchPage: '#SearchPage',
      siteAnnouncement: '#SiteAnnouncement',
      announcementWrapper: '#AnnouncementWrapper',
      searchBtn: '.js-search-header',
      modeBtn: '.js-theme-mode',
      closeSearch: '[data-search-close]',
      searchContainer: '.site-header__search-container',
      logo: '#LogoContainer img',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level'/*,
      search_wrapper: '#predictive-search'*/
    };
  
    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused'
    };
  
    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      overlayEnabledClass: 'header-wrapper--overlay',
      stickyEnabled: false,
      stickyActive: false,
      stickyHeaderWrapper: 'StickyHeaderWrap',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0,

      dynamicBarEnabled: false,
      stickyBarEnabled: false,
      stickyBarClass: 'announcement--stuck',
      stickyBarTransitionClass: 'announcement-bar--opening',
    };
  
    var wrapper;
    var siteHeader;
    var searchPage;
    var siteAnnouncement;
    var announcementWrapper;
    var announcementHeight;
    var toolbarWrapper;
    var siteHeaderPadding = 0
  
    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      toolbarWrapper = Shopify.designMode
      siteHeader = document.querySelector(selectors.siteHeader);
      searchPage = document.querySelector(selectors.searchPage);
      siteAnnouncement = document.querySelector(selectors.siteAnnouncement);
      announcementWrapper = document.querySelector(selectors.announcementWrapper);

      if (siteHeader.classList.contains("site-header-blurred")) {
        siteHeaderPadding = 20
      }

      config.dynamicBarEnabled = (announcementWrapper && announcementWrapper.dataset.dynamic === 'true') ? true : false;
      config.stickyBarEnabled = (announcementWrapper && announcementWrapper.dataset.sticky === 'true') ? true : false;
      config.stickyEnabled = (siteHeader && siteHeader.dataset.sticky === 'true') ? true : false;
      config.wrapperOverlayed = wrapper ? wrapper.classList.contains(config.overlayedClass) : false

      if (config.stickyEnabled) {
        siteHeader.classList.add('site-header--sticky');
      }
      
      if (!siteHeader) {
        return
      }
      
      stickyHeader();
  
      theme.settings.overlayHeader = (siteHeader.dataset.overlay === 'true');

      
      accessibleDropdowns();
      searchDrawer();
      
            
      var autoDarkmode = (siteHeader.dataset.darkmode === 'true')
	  var buttonWasActivated = Cookies.get('theme-mode-set')

      if (autoDarkmode) {        
        if (buttonWasActivated != 'true') {
          var sunrise = siteHeader.dataset.sunrise
          var sunset = siteHeader.dataset.sunset

          if (sunrise) {
            let currentHour = (new Date()).getHours();
            if (currentHour >= parseInt(sunrise)) {
              changeThemeMode()
            }
          }

          if (sunset) {
            let currentHour = (new Date()).getHours();
            if (currentHour >= parseInt(sunset) || currentHour < sunrise) {
              changeThemeMode('dark')
            }
          }  
        }
        themeMode();
      }

      window.on('load' + config.namespace, resizeLogo);
      //window.on('resize' + config.namespace, theme.Helpers.debounce(150, resizeLogo));
      var windowWidth = window.innerWidth
      window.on('resize' + config.namespace, theme.Helpers.debounce(150, function() {
        if (window.innerWidth != windowWidth) {windowWidth = window.innerWidth}else{return}
        resizeLogo();
      }.bind(this)));

      window.on('load' + config.namespace, cartDrawerHeader);
      //window.on('resize' + config.namespace, cartDrawerHeader);
      window.on('resize' + this.namespace, function() {
        if (window.innerWidth != windowWidth) {windowWidth = window.innerWidth}else{return}
        cartDrawerHeader();
      }); 

      window.on('load' + config.namespace, resizeHeader);

      if (window.scrollY > 17) {
        wrapper.classList.remove(config.overlayedClass);
      }

      window.on('scroll' + config.namespace, scrollHandler);

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', function(event) {
          resizeLogo()
          cartDrawerHeader()
          resizeHeader()
        });
      }
    }

    function resizeHeader() {
      var announcementBar = document.querySelector('#SiteAnnouncement')
        announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;

      var stickyHeaderWrapper = document.querySelector('#' + config.stickyHeaderWrapper)
      
      if (announcementBar) {
        var announcementWrapper = document.querySelector('#AnnouncementWrapper')
          
        if (config.stickyEnabled && config.stickyBarEnabled && document.querySelector('.site-header-container')) {
          document.querySelector('.site-header-container').style.top = announcementHeight + "px";
          announcementWrapper.style.height =  announcementHeight + "px";
        }
        announcementWrapper.style.height =  announcementHeight + "px";
      }
           
      if (config.dynamicBarEnabled) {
        document.querySelectorAll('.drawer__mobile-nav').forEach(el => {
          if (config.stickyBarEnabled || window.scrollY < announcementHeight) {
            el.style.top = announcementHeight + 'px';
          } else {
            el.style.top = 0 + 'px';
          }
        })
      }

      if (stickyHeaderWrapper) {
        if (config.wrapperOverlayed) {
          //stickyHeaderWrapper.style.height = document.querySelector('#SiteHeader').offsetHeight + 'px'
        } else {        
          stickyHeaderWrapper.style.height = document.querySelector('#SiteHeader').offsetHeight // announcementHeight - 1 + 'px'
        }
      }
    }
    
    function cartDrawerHeader() {
      var header_height = document.querySelector('#SiteHeader').offsetHeight;

      if (document.getElementById('CartDrawerHeader') != null && toolbarWrapper == true || document.getElementById('CartDrawerHeader') != null && toolbarWrapper == undefined) {
        var cartDrawer = document.getElementById('CartDrawerHeader')
        if (cartDrawer.dataset.height == 'announcement') {
          var announcement_height = document.querySelector('#SiteAnnouncement').offsetHeight;
          cartDrawer.setAttribute("style", "height:" + announcement_height + "px!important");
        } else if (cartDrawer.dataset.height == 'header') {          
          cartDrawer.setAttribute("style", "height:" + header_height + "px!important");
        }
      }

      document.querySelector('#MenuMobileHeader').style.setProperty('--drawer-height', header_height + "px");
      
    }
  
    function stickyHeader() {
      config.lastScroll = 0;
  
      var wrapperDiv = document.createElement('div');
      wrapperDiv.id = config.stickyHeaderWrapper;
      theme.Helpers.wrap(siteHeader, wrapperDiv);
  
      stickyHeaderHeight();

      if (Shopify && Shopify.designMode) {
        setTimeout(function() {
          stickyHeaderHeight();
          scrollHandler();
        }, 250);
      }
    }
  
    function stickyHeaderHeight() {
      var announcement_height = 0;

      const resizeAnnouncement = new ResizeObserver(function(entries) {
        resizeHeader()
      });
      
      if (document.querySelector('.announcement-bar') != null) {
        announcement_height = document.querySelector('.announcement-bar').offsetHeight
        resizeAnnouncement.observe(document.querySelector('#SiteAnnouncement'));
      }
    }
  
    function scrollHandler() {
      config.lastScroll = window.scrollY;
      var paddingTrigger = (announcementHeight > 30) ? announcementHeight : 30;

      if (window.scrollY >= paddingTrigger) {
        if (config.stickyActive) {
          return;
        }
        
        config.stickyActive = true;

        if (config.wrapperOverlayed && config.stickyEnabled) {
          wrapper.classList.remove(config.overlayedClass);
        }
  
        cartDrawerHeader();
        
        var isBarClosed = Cookies.get('isBarClosed');

        if (config.stickyBarEnabled && isBarClosed != 'true') {
        } else {
          setTimeout(function() {
            
            if (siteHeader != null) {
              //siteHeader.classList.add(config.openTransitionClass);
            }
            if (siteAnnouncement != null) {
              siteAnnouncement.classList.add(config.stickyBarTransitionClass);
            }
            
            if (searchPage != null) {
              //searchPage.classList.add(config.openTransitionClass);
            }

            if (config.dynamicBarEnabled) {
              document.querySelectorAll('.drawer__mobile-nav').forEach(el => {
                if (config.stickyBarEnabled) {
                  el.style.top = announcementHeight + 'px';
                } else {
                  el.style.top = 0 + 'px';
                }
              })
            }
          }, 100);
        }
      } else {
        if (!config.stickyActive) {
          return;
        }
        
        config.stickyActive = false;
  
        if (siteHeader != null) {
          siteHeader.classList.remove(config.openTransitionClass); 
        }        
        if (siteAnnouncement != null) {
          siteAnnouncement.classList.remove(config.stickyBarTransitionClass);
        }        
        if (searchPage != null) {
          searchPage.classList.remove(config.openTransitionClass);
        } 
        if (config.stickyBarEnabled) {
          siteHeader.style.top = (0 + siteHeaderPadding)+'px'
        }
        if (config.wrapperOverlayed) {
          wrapper.classList.add(config.overlayedClass);
        }
        
        /*document.querySelector('.drawer__mobile-nav').style.top = announcementHeight + 'px';
        
        if (config.dynamicBarEnabled && document.querySelector('#CartDrawer') != null) {
          document.querySelector('#CartDrawer').style.top =  announcementHeight + "px";
        }*/

        document.querySelectorAll('.drawer__mobile-nav').forEach(el => {
          if (config.dynamicBarEnabled) {
            el.style.top = announcementHeight + 'px';
          }
        })
        
        cartDrawerHeader();
        
      }
    }
  
    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;
  
      if (theme.config.isTouch) {
        document.querySelectorAll(selectors.navLinksWithDropdown).forEach(el => {
          el.on('touchend' + config.namespace, function(evt) {
            var parent = evt.currentTarget.parentNode;
            if (!parent.classList.contains(classes.dropdownActive)) {
              evt.preventDefault();
              closeDropdowns();
              openFirstLevelDropdown(evt.currentTarget);
            } else {
              window.location.replace(evt.currentTarget.getAttribute('href'));
            }
          });
        });
      }
  
      document.querySelectorAll(selectors.navLinks).forEach(el => {
        el.on('focusin' + config.namespace, accessibleMouseEvent);
        el.on('mouseover' + config.namespace, accessibleMouseEvent);
        el.on('mouseleave' + config.namespace, closeDropdowns);
      });
  
      document.querySelectorAll(selectors.navDropdownLinks).forEach(el => {
        if (theme.config.isTouch) {
          el.on('touchend' + config.namespace, function(evt) {
            var parent = evt.currentTarget.parentNode;
  
            // Open third level menu or go to link based on active state
            if (parent.classList.contains(classes.hasSubDropdownClass)) {
              if (!parent.classList.contains(classes.dropdownActive)) {
                evt.preventDefault();
                closeThirdLevelDropdown();
                openSecondLevelDropdown(evt.currentTarget);
              } else {
                window.location.replace(evt.currentTarget.getAttribute('href'));
              }
            } else {
              window.location.replace(evt.currentTarget.getAttribute('href'));
            }
          });
        }
  
        el.on('focusin' + config.namespace, function(evt) {
          closeThirdLevelDropdown();
          openSecondLevelDropdown(evt.currentTarget, true);
        })
      });
  
      function accessibleMouseEvent(evt) {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }
  
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }
  
        openFirstLevelDropdown(evt.currentTarget);
      }

      function openFirstLevelDropdown(el) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasDropdownClass)) {
          parent.classList.add(classes.dropdownActive);
          hasActiveDropdown = true;
        }
  
        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? 'touchend' : 'click';
            closeOnClickActive = true;
            document.documentElement.on(eventType + config.namespace, function() {
              closeDropdowns();
              document.documentElement.off(eventType + config.namespace);
              closeOnClickActive = false;
            }.bind(this));
          }
        }
      }
  
      function openSecondLevelDropdown(el, skipCheck) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasSubDropdownClass) || skipCheck) {
          parent.classList.add(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }
  
      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }
  
      function closeSecondLevelDropdown() {
        document.querySelectorAll(selectors.navItems).forEach(el => {
          el.classList.remove(classes.dropdownActive)
        });
      }
  
      function closeThirdLevelDropdown() {
        document.querySelectorAll(selectors.navDropdownLinks).forEach(el => {
          el.parentNode.classList.remove(classes.dropdownActive);
        });
      }
    }

    function searchDrawer() {
      document.querySelectorAll(selectors.searchBtn).forEach(btn => {
        btn.addEventListener('click', openSearchDrawer);
      });

      if (document.querySelector(selectors.closeSearch)) {
        document.querySelectorAll(selectors.closeSearch).forEach(btn => {
          btn.addEventListener('click', closeSearchDrawer);
        });
        
      }
    }
  
    function openSearchDrawer(evt) {
      var searchButton = evt.target.closest(".site-nav__link")
      if (searchButton && searchButton.dataset.hidden == "false") {
        searchButton.parentElement.querySelector(".site-header__search-input").focus()
      } else {

        evt.preventDefault();
        evt.stopImmediatePropagation();
        var container = document.querySelector(selectors.searchContainer);
        container.classList.add('is-active');
    
        //emit predictive search open event
        document.dispatchEvent(new CustomEvent('predictive-search:open', {
          detail: {
            context: 'header'
          },
          bubbles: true
        }));

        document.documentElement.classList.add('js-drawer-open', 'js-drawer-open--search');

        var announcementBar = document.querySelector(".site-announcement-container");
        if (announcementBar) {
          announcementBar.style.zIndex = "29"
        }
        
        enableCloseListeners();
      }
    }

    function enableCloseListeners() {
      // Clicking out of search area closes it. Timeout to prevent immediate bubbling
      setTimeout(function() {
        window.on('click' + config.namespace, function(evt) {
          closeSearchDrawer(evt);
        });
      }, 0);
  
      // Esc key also closes search
      window.on('keyup', function(evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      });
  
      //listen for predictive-search:close
      document.addEventListener('predictive-search:close-all', function() {
        closeSearchDrawer();
      }, { once: true });
    }
  
    function closeSearchDrawer(evt) {
      if (evt) {
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains('site-header__close-btn')) {
              break;
            }
  
            if (path[i].classList.contains('site-header__search-container')) {
              return;
            }
          }
        }
      }

      //emit predictive search close event
      document.dispatchEvent(new CustomEvent('predictive-search:close', { bubbles: true }));

      var announcementBar = document.querySelector(".site-announcement-container");
      if (announcementBar) {
        announcementBar.style.zIndex = "27"
      }

      document.activeElement.blur();  
      document.documentElement.classList.add('js-drawer-closing');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
      document.documentElement.querySelectorAll(".site-header__search-input").forEach(field => {
        field.value = ""
      });
  
      window.setTimeout(function() {
        document.documentElement.classList.remove('js-drawer-closing');
      }.bind(this), 500);
  
      var container = document.querySelector(selectors.searchContainer);
      theme.Helpers.prepareTransition(container, function() {
        container.classList.remove('is-active');
      }.bind(this));
  
      slate.a11y.removeTrapFocus({
        container: container,
        namespace: 'header_search'
      });
  
      slate.a11y.unlockMobileScrolling(config.namespace);
  
      unbindSearchEvents();
    }
  
    function bindSearchEvents() {
      window.on('keyup' + config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      }.bind(this));
  
      window.on('click' + config.namespace, function(evt) {
        closeSearchDrawer(evt);
      }.bind(this));
    }
  
    function unbindSearchEvents() {
      window.off('keyup' + config.namespace);
      window.off('click' + config.namespace);
    }
    
    function themeMode() {
      document.querySelectorAll(selectors.modeBtn).forEach(btn => {
        btn.addEventListener('click', changeThemeMode);
      });
    }
    
    function changeThemeMode(mode) {
      var themeMode = document.documentElement.getAttribute("data-theme");
	  var defaultClass = ".site-header__logo-default"
      var invertClass = ".site-header__logo-white"

      if (themeMode == mode) {
        return
      }

      if (themeMode != "dark") {
        document.documentElement.setAttribute('data-theme', "dark");
      } else {
        document.documentElement.setAttribute('data-theme', null);
      }
      
      document.querySelectorAll(".site-header__logo").forEach(logoWrapper => {
        if (themeMode != "dark") {
		  defaultClass = logoWrapper.querySelector(".site-header__logo-default")
          invertClass = logoWrapper.querySelector(".site-header__logo-white")
        } else {
          defaultClass = logoWrapper.querySelector(".site-header__logo-white")
          invertClass = logoWrapper.querySelector(".site-header__logo-default")
        }

        if(defaultClass && invertClass) {
          defaultClass.classList.remove("logo--has-inverted")
          defaultClass.classList.add("logo--inverted")
          
          invertClass.classList.remove("logo--inverted")
          invertClass.classList.add("logo--has-inverted")
        }
      });
      
      themeMode = document.documentElement.getAttribute("data-theme");

      Cookies.set('theme-mode', themeMode, { path: '/', expires: 200 });
      Cookies.set('theme-mode-set', 'true', { path: '/', expires: 200 });
    }

    /*function updateLogo() {
    }*/
  
    function resizeLogo(evt) {
      document.querySelectorAll(selectors.logo).forEach(logo => { 
        var logoWidthOnScreen = logo.clientWidth;
        var containerWidth = logo.closest('.grid__item-header').clientWidth;
  
        // If image exceeds container, let's make it smaller
        if (logoWidthOnScreen > containerWidth) {
          logo.style.maxWidth = containerWidth;
        } else {
          logo.removeAttribute('style')
        }
      });

      document.querySelectorAll(".site-header__logo--width").forEach(logo => {
        logo.width = logo.parentElement.parentElement.offsetWidth; 
        logo.height = (logo.width*(logo.naturalHeight/logo.naturalWidth));  
      });
    }
  
    return {
      init: init,
      resizeHeader: resizeHeader
    };
  })();
  
  /**
   * Search page
   * -----------------------------------------------------------------------------
   * This builds the collection grids for search bar and search page
   *
   *
   * @namespace a11y
   */
  
  theme.SearchPage = (function() {
    var selectors = {
      sortSelect: '#SortBy',
      sortBtn: '.filter-sort',
  
      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image',
  
      viewChange: '.grid-view-btn',
      productGrid: '.product-grid',
  
      collectionGrid: '.collection-grid__wrapper',
      sidebar: '#CollectionSidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list input',
      activeTags: '.tag-list a',
      tagsForm: '.filter-form',
      filterBar: '.filters-toolbar',
      priceRange: '.price-range',
      trigger: '.collapsible-trigger',
  
      filters: '.filter-wrapper',
      sidebarWrapper: '#CollectionSidebarFilterWrap',
      inlineWrapper: '#CollectionInlineFilterWrap',
    };
    
    function SearchPage(container) {
      this.container = container;
      this.containerId = container.id;
      this.sectionId = container.getAttribute('data-section-id');
      this.init(container);
    }
    
    SearchPage.prototype = Object.assign({}, SearchPage.prototype, {
      init: function(container) {
        if (!container) {
          this.container = document.getElementById(this.containerId);
        }
  		
        this.initGridOptions();

        this.resize()
      },
  
  
      initGridOptions: function() {
        var grid = this.container.querySelector(selectors.productGrid);
        var viewBtns = this.container.querySelectorAll(selectors.viewChange);
        this.container.querySelectorAll(selectors.viewChange).forEach(btn => {
          btn.addEventListener('click', function() {
            viewBtns.forEach(el=>{
              el.classList.remove('is-active');
            });
            btn.classList.add('is-active');
            var newView = btn.dataset.view;
            grid.dataset.view = newView;

            // Set as cart attribute so we can access in liquid
            theme.cart.updateAttribute('product_view', newView);

            // Trigger resize to update layzloaded images
            window.dispatchEvent(new Event('resize'));
          });
        });
      },

      resize: function() {
        var announcementBar = document.querySelector('#SiteAnnouncement');
        var header_height = document.querySelector('#SiteHeader').scrollHeight;
    
        var announcement_height = 0;
        if (announcementBar != null) {
          announcement_height = announcementBar.offsetHeight
        }
    
        document.getElementById('SearchPage').style.height = header_height + 'px';
        document.getElementById('SearchPageForm').style.height = header_height + 'px';
        document.getElementById('SearchPage').style.transform = 'translate3d(0px,' + announcement_height + 'px, 0)';
        setTimeout(function() {
          document.getElementById('SearchPage').style.transition = "transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)";
        }, 100);
      }     
    });
    
    return SearchPage;
  })();

  /*============================================================================
    PredictiveSearch
  ==============================================================================*/
  
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.enabled = true
      this.context = this.getAttribute('data-context');
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
      this.closeBtn = this.querySelector('.btn--close-search');
      this.screen = this.querySelector('[data-screen]');
      this.SearchModal = this.closest('#SearchModal') || null;

      this.siteHeader = document.querySelector('#SiteHeader') || null 
      this.isBoxed = this.siteHeader && this.siteHeader.classList.contains("site-header-blurred") ? true : false

      // Open events
      document.addEventListener('predictive-search:open', e => {
        if (e.detail.context !== this.context) return;
        this.classList.add('is-active');
        // Wait for opening events to finish then apply focus
        setTimeout(() => { this.input.focus();}, 500);
      });
  
      // listen for class change of 'modal--is-active on this.SearchModal
      if (this.SearchModal) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class') {
              const modalClass = mutation.target.className;
              if (modalClass.indexOf('modal--is-active') > -1) {
                setTimeout(() => { this.input.focus(); }, 500);
              }
            }
          });
        });
  
        observer.observe(this.SearchModal, {
          attributes: true
        });
      }
  
      if (this.enabled === 'false') return;
  
      // On typing
      this.input.addEventListener('keydown', () => { this.classList.add('is-active'); });

      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
  
      // Close events
      document.addEventListener('predictive-search:close', () => { this.close(); });
      document.addEventListener('keydown', (event) => { if (event.keyCode === 27) this.close(); });
      this.closeBtn.addEventListener('click', e => { e.preventDefault(); this.close(); });
      this.screen.addEventListener('click', () => { this.close(); });
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }

      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      const searchObj = {
        'q': searchTerm,
        'resources[limit]': 6,
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last'
      };

      const params = this.paramUrl(searchObj);
      fetch(`${theme.routes.predictiveSearch}?${params}&section_id=search-results`)
        .then((response) => {         
          if (!response.ok) {
            const error = new Error(response.status);
            this.close();
            throw error;
          }
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-results').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  
    open() {
      
      var header_height = this.siteHeader ? this.siteHeader.offsetHeight : 0; 
      var announcement_height = document.querySelector('#SiteAnnouncement') ? document.querySelector('#SiteAnnouncement').offsetHeight : 0;
      var searchHeaderHeight = document.querySelector("#SearchPageForm") ? document.querySelector("#SearchPageForm").offsetHeight : 0

      document.querySelectorAll('.search__results').forEach((el) => {
        var boxedContentPadding = 0
        if (this.isBoxed) {
          boxedContentPadding = 50
        }

        el.style.height = 'calc(100vh - ' + (header_height + announcement_height - 10 + boxedContentPadding) + 'px)'
      });
      
      this.predictiveSearchResults.style.display = 'block';
      document.body.classList.add('predictive-overflow-hidden');

      if (this.siteHeader && this.siteHeader.dataset.overlay == "true") {
        this.siteHeader.classList.add("active_search--background")
      }

      this.predictiveSearchResults.classList.add("is-active")

      this.lockScrolling()
    }
  
    close() {
      this.unlockScrolling();
      
      this.predictiveSearchResults.classList.remove("is-active");
      this.predictiveSearchResults.style.display = 'none';
      this.predictiveSearchResults.innerHTML = '';      
      
      this.classList.remove('is-active');
      document.body.classList.remove('predictive-overflow-hidden');
  
      document.dispatchEvent(new CustomEvent('predictive-search:close-all'));

      //var siteHeader = document.querySelector('#SiteHeader')
      if (this.siteHeader) {
        this.siteHeader.classList.remove("active_search--background")
      }
    }

    lockScrolling() {
      var backToTop = document.querySelector('.btn--back-to-top');
      if (backToTop) {
        backToTop.style.zIndex = 0
      }
      
      document.documentElement.classList.add('lock-scroll');
      document.documentElement.classList.add('js-search-open');
      
      document.documentElement.on('touchmove', function() {
        return true;
      });
    }
  
    unlockScrolling() {
      var backToTop = document.querySelector('.btn--back-to-top');
      if (backToTop) {
        backToTop.style.zIndex = 150
      }
      
      document.documentElement.classList.remove('lock-scroll');
      document.documentElement.classList.remove('js-search-open');
      document.documentElement.off('touchmove');
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  
    paramUrl(obj) {
      return Object.keys(obj).map(function(key) {
        return key + '=' + encodeURIComponent(obj[key]);
      }).join('&')
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);

  theme.UpsellSlider = (function() {
    var defaults = {
      adaptiveHeight: false,
      avoidReflow: true,
      pageDots: false,
      autoPlay: true,
      pauseAutoPlayOnHover: true,
      prevNextButtons: true
    };

    function UpsellSlider(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.upsellproducts-' + sectionId);
      this.namespace = '.upsellproduct-' + sectionId;

      if (!this.slideshow) { 
        return 
      }

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
    
    UpsellSlider.prototype = Object.assign({}, UpsellSlider.prototype, {
      init: function() {
        defaults.wrapAround = true;
        
        var windowWidth = window.screen.width < window.outerWidth ? window.screen.width : window.outerWidth;
        if (windowWidth < 590) {
          defaults.prevNextButtons = false
        }
 
        this.flickity = new theme.Slideshow(this.slideshow, defaults);

        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 1) {
          setTimeout(function() {
            this.flickity.goToSlide(1);
          }.bind(this), 200);
        }
      }
    });
  
    return UpsellSlider
  })();

  function DOMProductready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  DOMProductready(function(){
    theme.sections.register('header-section', theme.HeaderSection);
    theme.sections.register('cart-template', theme.Cart);   
    theme.sections.register('searchpage-template', theme.SearchPage);
    theme.sections.register('upsell-slider', theme.UpsellSlider);
  });
})();